<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-level-test`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44 41a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2a1 1 0 011-1h40zM9 39a2 2 0 01-2-2V21a2 2 0 012-2h8v-6a2 2 0 012-2h8V5a2 2 0 012-2h10a2 2 0 012 2v32a2 2 0 01-2 2H9zm8-16h-6v12h6V23zm10-8h-6v20h6V15zm10-8h-6v28h6V7z"/></svg>
</template>
<script>

export default {
  name: 'IconLevelTest',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
